module.exports = __webpack_public_path__ + "components/location-subheader/static/background--4-156e68b67bc425e3c00d61f8fdce35a3.jpg";